import CurrencyInput from 'react-currency-input-field';

// CustomerForm passes the raw numeric placeholder (e.g. "1250000") because
// that same string is also used verbatim as the submitted value when a
// field is left blank (see CustomerForm.handleSubmit). Format only the
// displayed placeholder text here so the two uses don't have to agree.
function formatPlaceholder(placeholder) {
  if (placeholder == null || placeholder === '') return placeholder;
  const num = Number(placeholder);
  return Number.isNaN(num) ? placeholder : num.toLocaleString('ko-KR');
}

// Wraps react-currency-input-field so money fields show live thousand
// separators while keeping the surrounding form's plain numeric-string
// state model (CustomerForm.validate()/toPayload() call parseFloat(form[key])).
function ReportMoneyInput({ value, onValueChange, placeholder, ...inputProps }) {
  return (
    <CurrencyInput
      {...inputProps}
      type="text"
      inputMode="numeric"
      value={value ?? ''}
      placeholder={formatPlaceholder(placeholder)}
      onValueChange={(rawValue) => {
        onValueChange(rawValue ?? '');
      }}
      intlConfig={{ locale: 'ko-KR', style: 'decimal', maximumFractionDigits: 0 }}
      groupSeparator=","
      allowDecimals={false}
      allowNegativeValue={false}
      disableAbbreviations
    />
  );
}

export default ReportMoneyInput;
